import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-zoomin',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconZoomin {

  render() {
    return (
      <svg viewBox="-1 -2 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M11.6 5a.6.6 0 0 1 .6.6v10.8a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6V5.6a.6.6 0 0 1 .6-.6z"/>
  <path d="M5 10.4a.6.6 0 0 1 .6-.6h10.8a.6.6 0 0 1 .6.6v1.2a.6.6 0 0 1-.6.6H5.6a.6.6 0 0 1-.6-.6z"/>
</svg>

    );
  }
}
